import(/* webpackMode: "eager", webpackExports: ["ClientSearchPage"] */ "/home/runner/work/porta-web/porta-web/apps/porta/app/search/ClientSearchPage.tsx");
